
/**
 * Helper to format strings containing HTML tags
 */
export class HtmlFormatHelper {

    /**
     * Remove HTML tags and verify dangerous code to prevent JS injection.
     * 
     * @param htmlContent - The html content as a string to verify
     */
    public static cleanHtml(htmlContent: string) {
        // Remove all HTML tags
        let reg: RegExp = new RegExp('<.[^>]*>', 'gi');
        htmlContent = htmlContent.replace(reg, '');
    
        // Remove potentially dangerous unclosed tags
        reg = new RegExp('<(script|iframe|frame|embed|object|img|xss|input|a|span|div|form|html|head|body|style|svg|bgsound|link|meta|table|tr|td|th|base|xml|applet|video|isindex)[^a-zA-Z0-9].*', 'gi');
        htmlContent = htmlContent.replace(reg, '');
    
        return htmlContent;
    }
}
